import { render, staticRenderFns } from "./WeekCalendarEvent.vue?vue&type=template&id=7c401576"
import script from "./WeekCalendarEvent.vue?vue&type=script&lang=js"
export * from "./WeekCalendarEvent.vue?vue&type=script&lang=js"
import style0 from "./WeekCalendarEvent.vue?vue&type=style&index=0&id=7c401576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports